import React, { useState } from "react";
import {
  useGetSecMagasinsQuery,
  useGetSelectionsQuery,
} from "../../../redux/features/cache";
import { SecMagasin } from "../../../models/SecMagasin";
import { Section } from "../../../models/Section";
import ModificationSection from "./ModificationSection";
import FormMagasin from "../../planogramme/components/Forms/FormMagasin";
import { Box, Button, Typography } from "@mui/material";
import ModificationSelection from "./ModificationSelection";
import SelectionForm from "./SelectionForm";
import MagasinForm from "./MagasinForm";
import {
  TabStrip,
  TabStripSelectEventArguments,
  TabStripTab,
} from "@progress/kendo-react-layout";
import { useAppSelector } from "../../../redux/store";

interface IWrapperModification {
  section: Section | undefined;
  handleClose: any;
}

function WrapperModification({ section, handleClose }: IWrapperModification) {
  const { data: secMagasins = [] as SecMagasin[] } = useGetSecMagasinsQuery(
    {
      sec: section?.plans_seq,
      mag: "",
    },
    { skip: !section }
  );
  const { data: selections = [] as Selection[] } = useGetSelectionsQuery(
    {
      section: section?.plans_seq ? section?.plans_seq : -1,
    },
    { skip: !section }
  );
  const [addSelection, setAddSelection] = useState<Boolean>(false);
  const [addMagasin, setAddMagasin] = useState<Boolean>(false);
  const [selected, setSelected] = React.useState<number>(0);
  const d_inv026 = useAppSelector((state) => state.appState.d_inv026);

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  };

  return (
    <>
      <Typography variant="h5" sx={{ pb: 1, pl: 1, color: "#007bff" }}>
        Section
      </Typography>
      {section && (
        <ModificationSection section={section} handleClose={handleClose} />
      )}
      <Box sx={{ width: "100%", mt: 2 }}>
        <TabStrip selected={selected} onSelect={handleSelect}>
          <TabStripTab title="Selections">
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                sx={{
                  width: "300px",
                  borderRadius: "30px",
                  mb: 4,
                  backgroundColor: "#007bff",
                }}
                onClick={() => setAddSelection(true)}
                disabled={!d_inv026.canAdd}
              >
                {" "}
                Ajouter une sélection
              </Button>
            </Box>
            {addSelection && (
              <SelectionForm
                plans_seq={section?.plans_seq}
                setAddSelection={setAddSelection}
              />
            )}
            {selections.length > 0 &&
              selections.map((e: any, i) => (
                <ModificationSelection selections={e} />
              ))}
          </TabStripTab>
          <TabStripTab title="Magasins">
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                sx={{
                  width: "300px",
                  borderRadius: "30px",
                  mb: 4,
                  backgroundColor: "#007bff",
                }}
                onClick={() => setAddMagasin(true)}
                disabled={!d_inv026.canAdd}
              >
                {" "}
                Ajouter un magasin
              </Button>
            </Box>
            {addMagasin && (
              <Box>
                <MagasinForm
                  plans_seq={section?.plans_seq}
                  setOpen={setAddMagasin}
                  canDelete={d_inv026.canDelete}
                />
              </Box>
            )}
            {secMagasins.length > 0 &&
              secMagasins.map((e, i) => (
                <FormMagasin data={e} key={e.mag_num} />
              ))}
          </TabStripTab>
        </TabStrip>
      </Box>
    </>
  );
}

export default WrapperModification;
